import { Controller } from "@hotwired/stimulus"
import noUiSlider from 'nouislider'
import 'nouislider/dist/nouislider.css'

export default class extends Controller {
  static targets = [
    "weightInput", "sliderEl", "sumDisplay", "segment",
    "submitBtn", "pctDisplay", "statusText"
  ]

  connect() {
    this.form = this.element.querySelector('form')
    if (this.form) {
      this.form.addEventListener('input', () => this.markDirty())
    }

    this.sliders = {}
    this.sliderElTargets.forEach(el => {
      const key = el.dataset.key
      const color = el.dataset.color || "#3b82f6"
      const input = this.weightInputTargets.find(i => i.dataset.weightKey === key)
      const startValue = input ? Math.round(parseFloat(input.value || 0) * 100) : 0

      const slider = noUiSlider.create(el, {
        start: [startValue],
        range: { min: 0, max: 100 },
        step: 1,
        connect: 'lower',
        tooltips: false,
        pips: false
      })

      const connect = el.querySelector('.noUi-connect')
      if (connect) connect.style.background = color

      const handle = el.querySelector('.noUi-handle')
      if (handle) {
        handle.style.borderColor = color
        handle.style.boxShadow = `0 0 0 2px ${color}33`
      }

      slider.on('slide', (values) => {
        const val = parseFloat(values[0])
        this.onSliderChange(key, val)
      })

      this.sliders[key] = slider
    })

    this.updateSum()
  }

  onSliderChange(key, val) {
    const input = this.weightInputTargets.find(i => i.dataset.weightKey === key)
    if (input) {
      input.value = (val / 100).toFixed(2)
    }
    const idx = this.weightInputTargets.indexOf(input)
    if (this.hasPctDisplayTarget && this.pctDisplayTargets[idx]) {
      this.pctDisplayTargets[idx].textContent = Math.round(val) + "%"
    }
    this.updateSum()
  }

  inputChanged(e) {
    const input = e.target
    const key = input.dataset.weightKey
    const slider = this.sliders[key]
    if (slider) {
      const pct = Math.round(parseFloat(input.value) * 100)
      slider.set(isNaN(pct) ? 0 : pct)
    }
    const idx = this.weightInputTargets.indexOf(input)
    if (this.hasPctDisplayTarget && this.pctDisplayTargets[idx]) {
      const val = Math.round(parseFloat(input.value || 0) * 100)
      this.pctDisplayTargets[idx].textContent = val + "%"
    }
    this.updateSum()
  }

  updateSum() {
    let sum = 0
    this.weightInputTargets.forEach(input => {
      sum += parseFloat(input.value) || 0
    })

    const rounded = Math.round(sum * 100) / 100
    const valid = Math.abs(rounded - 1.0) < 0.011

    if (this.hasSumDisplayTarget) {
      this.sumDisplayTarget.textContent = rounded.toFixed(2)
      this.sumDisplayTarget.classList.toggle("text-green-700", valid)
      this.sumDisplayTarget.classList.toggle("text-red-600", !valid)
    }

    if (this.hasSegmentTarget) {
      this.segmentTargets.forEach(seg => {
        const key = seg.dataset.weightKey
        const input = this.weightInputTargets.find(i => i.dataset.weightKey === key)
        const val = parseFloat(input?.value || 0)
        const widthPct = sum > 0 ? Math.round((val / sum) * 100) : 0
        seg.style.width = widthPct + "%"
      })
    }

    if (this.hasSubmitBtnTarget) {
      this.submitBtnTarget.disabled = !valid
    }
  }

  markDirty() {
    if (this.hasStatusTextTarget) {
      this.statusTextTarget.textContent = "Есть несохранённые изменения"
      this.statusTextTarget.classList.remove("text-gray-400")
      this.statusTextTarget.classList.add("text-amber-600")
    }
  }

  resetForm() {
    if (confirm("Сбросить несохранённые изменения?")) {
      window.location.reload()
    }
  }
}
